import { createApiHooks, formDataPlugin } from '@apis/next/common';
import { RemoteFile } from '@models/next/FileType';
import { f } from '@utils/nextForms';
import { z } from 'zod';

export const fileUploadApis = createApiHooks('/file/upload', [
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        type: 'Body',
        name: 'file',
        schema: z.object({
          file: f.instanceOfBlob().array(),
        }),
      },
      {
        type: 'Query',
        name: 'file_upload_access',
        schema: z.string().optional(),
      },
    ],
    response: RemoteFile.array(),
  },
]);

fileUploadApis.client.use('post', '/file/upload', formDataPlugin());
